// extracted by mini-css-extract-plugin
module.exports = {"flag":"BookListItem_flag__2mQuF","gray":"BookListItem_gray__2jyWy"};